import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Header from '../components/Header';
import LightBox from '../components/LightBox';
import AdminBar from './admin/AdminBar';

import Api, { Utils } from '../Api';

import './App.less';
import './Button.css';
import './Form.less';

export default class App extends Component {
  constructor(props) {
    super(props);

    Utils.bindThis(
      this,
      [
        'isModalView',
        'doCloseModal',
        'willCloseModal'
      ]
    );

    if (this.props.location && this.props.location.query && this.props.location.query.campaign === "1") {
      Api.cache.setCampaignRetailerToken(this.props.location.query['retailer_token']);
    }

    // True if we're in the list of modal views
    this.isModal = false;

    // Children from the last view before we became modal, null if none.
    this.backgroundChildren = null;

    // Array with the list of routes that are to be handled as modal
    this.modalViews = [
      '/admin/brand/[^/]*/product/[^/]*/option/.*',
      '/admin/amazon/[^/]+'
    ];

    this.state = {
      user: Api.cache.getUser(),
      retailer: Api.cache.getRetailer(),
      adminBarVisible: Api.cache.getAdminBarVisible()
    };
  }

  componentWillMount() {
    Api.userStartListen(this, 'user');
    Api.startListen(this, 'retailer', Api.cache.eventTypes.RETAILER_CHANGED);
    Api.startListen(this, 'adminBarVisible', Api.cache.eventTypes.ADMIN_BAR_VISIBILITY_CHANGED);

    Api.getUser(true);
  }

  componentWillUnmount() {
    Api.userStopListen(this);
    Api.stopListen(this, Api.cache.eventTypes.RETAILER_CHANGED);
    Api.stopListen(this, Api.cache.eventTypes.ADMIN_BAR_VISIBILITY_CHANGED);
  }

  componentDidMount() {
    if (this.props.location && this.props.location.query && Object.keys(this.props.location.query).length > 0) {
      setTimeout(
        () => {
          this.context.router.replace(this.props.location.pathname);
        },
        200
      )
    }
  }

  isModalView(path) {
    let i;
    for (i = 0; i < this.modalViews.length; i++) {
      let normalPath = '^' + this.modalViews[i] + '$';
      
      if (path.match(normalPath)) return(true);
    }
    return(false);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.location.key !== nextProps.location.key) {
      let isModal = this.isModalView(nextProps.location.pathname);

      if (isModal && !this.isModal) {
        this.backgroundChildren = this.props.children;
      } else if (!isModal) {
        this.backgroundChildren = null;
      }

      this.isModal = isModal;
      nextProps.location.isModal = this.isModal;

      // onLocationChange
      let callback = window.onLocationChange;
      if (callback && typeof(callback) === 'function') {
        callback(nextProps.location);
      }

      // Event
      Api.event(nextProps.location.pathname);
    }
  }

  componentDidUpdate(oldProps, oldState) {
    if (this.state.user && !this.state.retailer) {
      if (this.state.user.retailer_token) {
        Api.getRetailer(this.state.user.retailer_token, true);
      }
    }
  }

  /**
   * Closes the modal. No questions asked.
   */
  doCloseModal() {
    if (!this.isModal) return;

    this.props.location.willCloseModal = null;
    this.context.router.goBack();
  }

  /**
   * This function is called when the user tries to close a modal.
   *
   * To change the way that the user may or may not close the modal, the value of `this.props.location.willCloseModal`
   * should be a function that will be called in this moment.
   * * Should the function return `false`, the modal will not close.
   * * Should the function return `true`, the modal will close.
   * * Should the function return an instance of the `Promise` object, the modal will close once the promise is
   * resolved. If rejected, no action will be taken.
   * * Any other return values are rejected and the modal will not be closed.
   */
  willCloseModal() {
    if (this.props.location.willCloseModal && typeof(this.props.location.willCloseModal) === 'function') {
      let ret = this.props.location.willCloseModal();

      if (ret === false) return;
      if (ret === true) {
        this.doCloseModal();
      }
      
      if (ret instanceof Promise) {
        ret.then(this.doCloseModal);
      }
    } else {
      this.doCloseModal();
    }
  }

  render() {
    let pageContents = this.isModal ? this.backgroundChildren : this.props.children;
    let modalContents = this.isModal ? <LightBox onClose={this.willCloseModal}>{this.props.children}</LightBox> : null;

    if (this.isModal) {
      document.body.classList.add('noscroll');
    } else {
      document.body.classList.remove('noscroll'); 
    }

    let className = 'app';
    let environment = (window.envName[0] === '{') ? 'development' : window.envName;
    if (window.envName !== 'production') {
      className += ' env-' + environment;
    }

    let adminBar = null;
    if (this.state.user && this.state.user.is_employee) {
      adminBar = <AdminBar />;
    }

    if (adminBar && this.state.adminBarVisible && this.props.location.pathname.indexOf('/retailer/') === 0) {
      document.body.classList.add('admin-bar-visible');
    } else {
      document.body.classList.remove('admin-bar-visible');
    }

    return (
      <div className={className}>
        <Header location={this.props.location}
                user={this.state.user}
                retailer={this.state.retailer}
                lastRetailerToken={Api.cache.getLastSelectedRetailerToken()}/>
        {adminBar}
        <div className="app-middle">
          {pageContents}
        </div>
        {modalContents}
      </div>
    );
  }
}

App.contextTypes = {
  router: PropTypes.object
};



/** WEBPACK FOOTER **
 ** ./src/views/App.js
 **/